import { render } from "./PersonIntroAllView.vue?vue&type=template&id=6ddab3ca&scoped=true"
import script from "./PersonIntroAllView.vue?vue&type=script&lang=js"
export * from "./PersonIntroAllView.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/personintro-all.css?vue&type=style&index=1&id=6ddab3ca&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddab3ca"]])

export default __exports__